/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BasketResponseModel,
  ModelStateEntry,
  PaymentMethod,
  PickupPoint,
  ShippingMethodReturnModel,
  UpdateBasketAddressModel,
  UpdateShippingModel,
  ValidationErrorResponse,
} from '../models/index';
import {
    BasketResponseModelFromJSON,
    BasketResponseModelToJSON,
    ModelStateEntryFromJSON,
    ModelStateEntryToJSON,
    PaymentMethodFromJSON,
    PaymentMethodToJSON,
    PickupPointFromJSON,
    PickupPointToJSON,
    ShippingMethodReturnModelFromJSON,
    ShippingMethodReturnModelToJSON,
    UpdateBasketAddressModelFromJSON,
    UpdateBasketAddressModelToJSON,
    UpdateShippingModelFromJSON,
    UpdateShippingModelToJSON,
    ValidationErrorResponseFromJSON,
    ValidationErrorResponseToJSON,
} from '../models/index';
import { HandleRequest } from '../../handle-request'
export type DeleteBasketRequest = {
    catalog: string;
    basketId?: string;
}

export type GetRequest = {
    catalog: string;
    basketId?: string;
}

export type GetPaymentMethodsRequest = {
    catalog: string;
    basketId?: string;
}

export type GetPaymentUrlRequest = {
    catalog: string;
    basketId?: string;
    paymentMethodId?: string;
}

export type GetPickupPointsRequest = {
    catalog: string;
    providerId?: string;
    postalCode?: string;
    basketId?: string;
}

export type GetShippingMethodsRequest = {
    catalog: string;
    basketId?: string;
}

export type SetAcceptNewsletterRequest = {
    catalog: string;
    basketId?: string;
    body?: boolean;
}

export type SetAcceptTermsRequest = {
    catalog: string;
    basketId?: string;
    body?: boolean;
}

export type SetShipmentRequest = {
    catalog: string;
    basketId?: string;
    updateShippingModel?: UpdateShippingModel;
}

export type UpdateAddressesRequest = {
    catalog: string;
    basketId?: string;
    updateBasketAddressModel?: UpdateBasketAddressModel;
}

export type UpdateNoteRequest = {
    catalog: string;
    basketId?: string;
    body?: string;
}



/**
 * 
 */
export class BasketApi extends runtime.BaseAPI {


    /**
     */
     deleteBasket = HandleRequest.Handle<DeleteBasketRequest,void>('BasketApi_deleteBasket',async (requestParameters: DeleteBasketRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>  => {
        if (requestParameters['catalog'] == null) {
            throw new runtime.RequiredError(
                'catalog',
                'Required parameter "catalog" was null or undefined when calling deleteBasket().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['basketId'] != null) {
            queryParameters['basketId'] = requestParameters['basketId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        let response = null;


         response = await this.request({
            path: `/api/{catalog}/basket`.replace(`{${"catalog"}}`, encodeURIComponent(String(requestParameters['catalog']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    })

    /**
     */


    /**
     */
     get = HandleRequest.Handle<GetRequest,BasketResponseModel>('BasketApi_get',async (requestParameters: GetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BasketResponseModel>>  => {
        if (requestParameters['catalog'] == null) {
            throw new runtime.RequiredError(
                'catalog',
                'Required parameter "catalog" was null or undefined when calling get().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['basketId'] != null) {
            queryParameters['basketId'] = requestParameters['basketId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        let response = null;


         response = await this.request({
            path: `/api/{catalog}/basket`.replace(`{${"catalog"}}`, encodeURIComponent(String(requestParameters['catalog']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BasketResponseModelFromJSON(jsonValue));
    })

    /**
     */


    /**
     */
     getPaymentMethods = HandleRequest.Handle<GetPaymentMethodsRequest,Array<PaymentMethod>>('BasketApi_getPaymentMethods',async (requestParameters: GetPaymentMethodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PaymentMethod>>>  => {
        if (requestParameters['catalog'] == null) {
            throw new runtime.RequiredError(
                'catalog',
                'Required parameter "catalog" was null or undefined when calling getPaymentMethods().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['basketId'] != null) {
            queryParameters['basketId'] = requestParameters['basketId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        let response = null;


         response = await this.request({
            path: `/api/{catalog}/basket/get-payment-methods`.replace(`{${"catalog"}}`, encodeURIComponent(String(requestParameters['catalog']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PaymentMethodFromJSON));
    })

    /**
     */


    /**
     */
     getPaymentUrl = HandleRequest.Handle<GetPaymentUrlRequest,string>('BasketApi_getPaymentUrl',async (requestParameters: GetPaymentUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>  => {
        if (requestParameters['catalog'] == null) {
            throw new runtime.RequiredError(
                'catalog',
                'Required parameter "catalog" was null or undefined when calling getPaymentUrl().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['basketId'] != null) {
            queryParameters['basketId'] = requestParameters['basketId'];
        }

        if (requestParameters['paymentMethodId'] != null) {
            queryParameters['paymentMethodId'] = requestParameters['paymentMethodId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        let response = null;


         response = await this.request({
            path: `/api/{catalog}/basket/get-payment-url`.replace(`{${"catalog"}}`, encodeURIComponent(String(requestParameters['catalog']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    })

    /**
     */


    /**
     */
     getPickupPoints = HandleRequest.Handle<GetPickupPointsRequest,Array<PickupPoint>>('BasketApi_getPickupPoints',async (requestParameters: GetPickupPointsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PickupPoint>>>  => {
        if (requestParameters['catalog'] == null) {
            throw new runtime.RequiredError(
                'catalog',
                'Required parameter "catalog" was null or undefined when calling getPickupPoints().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['providerId'] != null) {
            queryParameters['providerId'] = requestParameters['providerId'];
        }

        if (requestParameters['postalCode'] != null) {
            queryParameters['postalCode'] = requestParameters['postalCode'];
        }

        if (requestParameters['basketId'] != null) {
            queryParameters['basketId'] = requestParameters['basketId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        let response = null;


         response = await this.request({
            path: `/api/{catalog}/basket/get-pickup-points`.replace(`{${"catalog"}}`, encodeURIComponent(String(requestParameters['catalog']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PickupPointFromJSON));
    })

    /**
     */


    /**
     */
     getShippingMethods = HandleRequest.Handle<GetShippingMethodsRequest,Array<ShippingMethodReturnModel>>('BasketApi_getShippingMethods',async (requestParameters: GetShippingMethodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShippingMethodReturnModel>>>  => {
        if (requestParameters['catalog'] == null) {
            throw new runtime.RequiredError(
                'catalog',
                'Required parameter "catalog" was null or undefined when calling getShippingMethods().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['basketId'] != null) {
            queryParameters['basketId'] = requestParameters['basketId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        let response = null;


         response = await this.request({
            path: `/api/{catalog}/basket/get-shipping-methods`.replace(`{${"catalog"}}`, encodeURIComponent(String(requestParameters['catalog']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ShippingMethodReturnModelFromJSON));
    })

    /**
     */


    /**
     */
     setAcceptNewsletter = HandleRequest.Handle<SetAcceptNewsletterRequest,BasketResponseModel>('BasketApi_setAcceptNewsletter',async (requestParameters: SetAcceptNewsletterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BasketResponseModel>>  => {
        if (requestParameters['catalog'] == null) {
            throw new runtime.RequiredError(
                'catalog',
                'Required parameter "catalog" was null or undefined when calling setAcceptNewsletter().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['basketId'] != null) {
            queryParameters['basketId'] = requestParameters['basketId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        let response = null;


         response = await this.request({
            path: `/api/{catalog}/basket/accept-newsletter`.replace(`{${"catalog"}}`, encodeURIComponent(String(requestParameters['catalog']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BasketResponseModelFromJSON(jsonValue));
    })

    /**
     */


    /**
     */
     setAcceptTerms = HandleRequest.Handle<SetAcceptTermsRequest,BasketResponseModel>('BasketApi_setAcceptTerms',async (requestParameters: SetAcceptTermsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BasketResponseModel>>  => {
        if (requestParameters['catalog'] == null) {
            throw new runtime.RequiredError(
                'catalog',
                'Required parameter "catalog" was null or undefined when calling setAcceptTerms().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['basketId'] != null) {
            queryParameters['basketId'] = requestParameters['basketId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        let response = null;


         response = await this.request({
            path: `/api/{catalog}/basket/accept-terms`.replace(`{${"catalog"}}`, encodeURIComponent(String(requestParameters['catalog']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BasketResponseModelFromJSON(jsonValue));
    })

    /**
     */


    /**
     */
     setShipment = HandleRequest.Handle<SetShipmentRequest,BasketResponseModel>('BasketApi_setShipment',async (requestParameters: SetShipmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BasketResponseModel>>  => {
        if (requestParameters['catalog'] == null) {
            throw new runtime.RequiredError(
                'catalog',
                'Required parameter "catalog" was null or undefined when calling setShipment().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['basketId'] != null) {
            queryParameters['basketId'] = requestParameters['basketId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        let response = null;


         response = await this.request({
            path: `/api/{catalog}/basket/shipment`.replace(`{${"catalog"}}`, encodeURIComponent(String(requestParameters['catalog']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateShippingModelToJSON(requestParameters['updateShippingModel']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BasketResponseModelFromJSON(jsonValue));
    })

    /**
     */


    /**
     */
     updateAddresses = HandleRequest.Handle<UpdateAddressesRequest,BasketResponseModel>('BasketApi_updateAddresses',async (requestParameters: UpdateAddressesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BasketResponseModel>>  => {
        if (requestParameters['catalog'] == null) {
            throw new runtime.RequiredError(
                'catalog',
                'Required parameter "catalog" was null or undefined when calling updateAddresses().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['basketId'] != null) {
            queryParameters['basketId'] = requestParameters['basketId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        let response = null;


         response = await this.request({
            path: `/api/{catalog}/basket/address`.replace(`{${"catalog"}}`, encodeURIComponent(String(requestParameters['catalog']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBasketAddressModelToJSON(requestParameters['updateBasketAddressModel']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BasketResponseModelFromJSON(jsonValue));
    })

    /**
     */


    /**
     */
     updateNote = HandleRequest.Handle<UpdateNoteRequest,BasketResponseModel>('BasketApi_updateNote',async (requestParameters: UpdateNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BasketResponseModel>>  => {
        if (requestParameters['catalog'] == null) {
            throw new runtime.RequiredError(
                'catalog',
                'Required parameter "catalog" was null or undefined when calling updateNote().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['basketId'] != null) {
            queryParameters['basketId'] = requestParameters['basketId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        let response = null;


         response = await this.request({
            path: `/api/{catalog}/basket/note`.replace(`{${"catalog"}}`, encodeURIComponent(String(requestParameters['catalog']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BasketResponseModelFromJSON(jsonValue));
    })

    /**
     */


}
